// extracted by mini-css-extract-plugin
module.exports = {"userProfile":"UserProfile_userProfile__1iYp7","header":"UserProfile_header__1rlWz","users":"UserProfile_users__2e8zo","user":"UserProfile_user__3GYPk"};